import React from 'react'
import { CSSTransition } from 'react-transition-group'
import PropTypes from 'prop-types'
import cx from 'classnames'
import SVG from 'react-inlinesvg'
import closeIcon from '../../../../../images/close.svg'
import ticketIcon from '../../../../../../assets/images/ticket.svg'

import './calendar-tooltip.css'

class CalendarTooltip extends React.PureComponent {
  render() {
    let {
      id,
      event,
      innerRef,
      visible,
      machineTime,
      date,
      time,
      dateTime,
      onDismiss,
      direction
    } = this.props

    let tooltipClasses = cx('calendar-tooltip', {
      'calendar-tooltip__left': direction === 'left',
      'calendar-tooltip__right': direction === 'right'
    })

    return (
      <CSSTransition
        nodeRef={innerRef}
        in={visible}
        timeout={0}
        classNames="calendar-tooltip"
      >
        <div
          id={id}
          tabIndex="0"
          ref={innerRef}
          className={tooltipClasses}
          role="tooltip"
        >
          <div className="flex">
            {this.renderTitle(event)}

            <button
              className="calendar-close-button text-depths"
              onClick={onDismiss}
            >
              <span className="sr-only">Close Tooltip</span>
              <SVG
                src={closeIcon}
                aria-hidden="true"
              />
            </button>
          </div>

          <time
            dateTime={machineTime}
            className="block font-bold text-12 text-depths uppercase"
          >
            {dateTime} at {time}
          </time>

          {this.renderTooltipContent(event)}

          <div className="hidden lg:block">
            {this.renderEcommButton(event, date)}
          </div>

          <div className="calendar-tooltip-actions flex flex-col flex-grow justify-end lg:hidden">
            <div className="mb-16">{this.renderEcommButton(event, date)}</div>

            <button
              className="button w-full bg-white text-depths border-2 border-depths"
              onClick={this.handleDismiss}
            >
              Close
            </button>
          </div>
        </div>
      </CSSTransition>
    )
  }

  renderTitle({ url, title }) {
    let classes =
      'block flex-grow font-bold text-16 no-underline mb-8 text-depths pr-24 mt-0'

    if (url) {
      return (
        <a
          href={url}
          className={classes}
        >
          {title}
        </a>
      )
    }

    return <p className={classes}>{title}</p>
  }

  renderTooltipContent({ url, title, description }) {
    if (!description) {
      return null
    }
    let lastPTagLocation = description.lastIndexOf('<p>')
    let lastClosingPTagLocation = description.lastIndexOf('</p>')
    // Setting margin-bottom to 0 after the last paragraph in the description
    description =
      description.slice(0, lastPTagLocation) +
      description.slice(lastPTagLocation).replace('<p>', '<p class="mb-0">')
    // Appending tool tip content link in the last paragraph of the description
    let toolTipContentLink = this.renderTooltipContentLink(url, title)
    if (toolTipContentLink) {
      description =
        description.slice(0, lastClosingPTagLocation) +
        description
          .slice(lastClosingPTagLocation)
          .replace('</p>', toolTipContentLink)
    }
    return (
      <span
        className="text-14 text-depths mb-0 leading-normal"
        dangerouslySetInnerHTML={{
          __html: description
        }}
      />
    )
  }

  renderTooltipContentLink(url, title) {
    if (!url) {
      return null
    }

    return `
      <a href=${url}>
        Learn More
        <span class="sr-only"> about ${title}</span>
      </a>
    `
  }

  renderEcommButton({ ecommUrl }) {
    if (ecommUrl) {
      let href = `${ecommUrl}`
      let classNames = `
        flex w-full button text-white bg-depths mt-20 leading-normal
        border-2 border-depths
      `

      return (
        <a
          href={href}
          className={classNames}
        >
          <SVG
            src={ticketIcon}
            width="16"
            height="16"
            aria-label="ticket"
            aria-hidden="true"
          />
          <span className="ml-12">Buy Tickets</span>
        </a>
      )
    }
  }

  handleDismiss = e => {
    this.props.onDismiss()
    e.preventDefault()
    e.stopPropagation()
  }
}

CalendarTooltip.propTypes = {
  id: PropTypes.string,
  event: PropTypes.object,
  time: PropTypes.string,
  dateTime: PropTypes.string,
  innerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  direction: PropTypes.oneOf(['left', 'right']),
  machineTime: PropTypes.string,
  onDismiss: PropTypes.func
}

export default CalendarTooltip
